<template>
    <div class="map" :id="initId">
      <div class="legend-my" v-if="false">
            <div class="left">
                <!-- 海温 -->
                <div class="right" v-if="false">
                    <p>15</p>
                    <p>25</p>
                </div>
                <!-- 海升 -->
                <div class="right" v-if="false">
                    <p>1</p>
                    <p>20</p>
                </div>
                <!-- 叶绿素 -->
                <div class="right" v-if="false">
                    <p>0</p>
                    <p>5</p>
                </div>
                <!-- 北部海温 -->
                <div class="right" v-if="true">
                    <p>20</p>
                    <p>30</p>
                </div>
            </div>
        </div>
      <!-- <div class="time-step">
        <StepV :arrayList="AllCollection" :arrayIndex="layerIndex" :showSFM="true"/>
      </div> -->
    </div>
</template>

<script>
import axios from '@/utils/axios.min'
let viewer
let fieldLayer //风场
const Cesium = window.Cesium
import Cesium_measure from "@/utils/CesiumMeasure"
// import StepV from "@/components/Steps"
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Object
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
          type: String
        },
        collections: {
          type: Array
        }
    },
    components:{
        // StepV
    },
    data(){
        return{
            CesiumMeasure:null,
            startTime:'',
            endTime:'',
            nowTime:'',
            showTime:null,
            AllCollection:[],
            layerIndex: 0,
            isFirst:true,
            loading:false,
            initWind:false,
            showWind:false,
        }
    },
    watch:{
      timeRange(val){
        if(val){
          this.isFirst = true
        }
      },
      isplay(val){
          if(!val&&this.is2d){
              if(this.isFirst){
                  this.AllCollection = []
                  this.layerIndex = 0
                  this.getLIST()
                  this.isFirst = false
              }else{
                this.addHeat()
              }
          }else{
              clearInterval(this.showTime)
          }
      }
    },
    destroyed(){
        clearInterval(this.showTime)
    },
    methods:{
        ceju(){
          this.CesiumMeasure.ceju()
        },
        cemian(){
          this.CesiumMeasure.cemian()
        },
        changeTime(time){
          let now = new Date(time),
              Y = now.getFullYear(),
              M = now.getMonth()+1,
              D= now.getDate()
            M = M<10?'0'+M:M;
            D = D<10?'0'+D:D;
            return Y+'-'+M+'-'+D;
        },
        opaContraol(oldNum,newNum,Oldlayer,newPM){
            let that = this
            console.log(oldNum,newNum);
            this.showTime = setInterval(function(){
                Oldlayer.alpha = 0
                newPM.alpha = 0.75
                clearInterval(that.showTime)
                viewer.imageryLayers.remove(Oldlayer)
                that.addHeat()
            },300)
        },
        addHeat(){
          const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + this.AllCollection[this.layerIndex].collection + '/tile.png?transparent=true&z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + this.AllCollection[this.layerIndex].name

          let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
            url: rootUrl,
            subdomains:["8091","8091","8091"],
            tilingScheme:new Cesium.GeographicTilingScheme({
              ellipsoid:Cesium.Ellipsoid.WGS84,
              numberOfLevelZeroTilesX:2,
              numberOfLevelZeroTilesY:1,
            }),
            customTags: {
              zindex: function(imageryProvider, x, y, level) {
                return level + 1
              }
            }
          });

          const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
          // imgLayer.transparentBackColor = Cesium.Color.WHITE
          // imgLayer.transparentBackColorTolerance = 0.5
          imgLayer.alpha = 0

          this.opaContraol(1,0.1,viewer.imageryLayers._layers[1],viewer.imageryLayers._layers[2])
          if (this.layerIndex === this.AllCollection.length - 1) {
            this.layerIndex = 0
            return
          }
          this.layerIndex++
        },
        getLIST(){
          const that = this
          const startTime = this.changeTime(this.timeRange[0]) + ' 00:00:00'
          const endTime = this.changeTime(this.timeRange[1]) + ' 23:59:59'
          const collectionNames = []
          this.collections.forEach(item => {
            collectionNames.push(item.resourceName)
          })
          const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
          axios.get(url).then(res => {
            res.data.features.forEach(feature => {
              that.AllCollection.push({
                collection: feature.collection,
                name: feature.assets.data.title,
                time:feature.properties.createtime
              })
            })
            const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + that.AllCollection[that.layerIndex].collection + '/tile.png?z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + that.AllCollection[this.layerIndex].name
            //开始前预加2张
            for(let i = 0;i<2;i++){
              let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
                url: rootUrl,
                subdomains:["8091","8091","8091"],
                tilingScheme:new Cesium.GeographicTilingScheme({
                  ellipsoid:Cesium.Ellipsoid.WGS84,
                  numberOfLevelZeroTilesX:2,
                  numberOfLevelZeroTilesY:1,
                }),
                customTags: {
                  zindex: function(imageryProvider, x, y, level) {
                    return level + 1
                  }
                }
              });

              const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
              imgLayer.transparentBackColor = Cesium.Color.WHITE
              imgLayer.transparentBackColorTolerance = 0.5
              if(i===0){
                imgLayer.alpha = 0.75
              }else{
                imgLayer.alpha = 0
              }
              that.layerIndex++
            }
            that.addHeat()
          })
        },
        addOne(){
          const that = this
          const startTime = this.changeTime(this.timeRange[0]) + ' 00:00:00'
          const endTime = this.changeTime(this.timeRange[1]) + ' 23:59:59'
          const collectionNames = []
          this.collections.forEach(item => {
            collectionNames.push(item.resourceName)
          })
          const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
          axios.get(url).then(res => {
            res.data.features.forEach(feature => {
              that.AllCollection.push({
                collection: feature.collection,
                name: feature.assets.data.title,
                time:feature.properties.createtime
              })
            })
            const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + that.AllCollection[this.layerIndex].collection + '/tile.png?z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + that.AllCollection[this.layerIndex].name
            //开始前预加7张
            let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
              url: rootUrl,
              subdomains:["8091","8091","8091"],
              tilingScheme:new Cesium.GeographicTilingScheme({
                ellipsoid:Cesium.Ellipsoid.WGS84,
                numberOfLevelZeroTilesX:2,
                numberOfLevelZeroTilesY:1,
              }),
              customTags: {
                zindex: function(imageryProvider, x, y, level) {
                  return level + 1
                }
              }
            });

            that.AllCollection.splice(1,that.AllCollection.length-1)

            const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
            imgLayer.transparentBackColor = Cesium.Color.WHITE
            imgLayer.transparentBackColorTolerance = 0.5
            imgLayer.alpha = 0.75
            that.layerIndex++
          })
        },
        initMap(){
            Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
            viewer = new Cesium.Viewer(this.initId,{
                animation: false, //创建动画部件
                shouldAnimate : true,
                orderIndependentTranslucency: false,
                contextOptions: {
                  webgl: { alpha: true},
                  requestWebgl2: true
                },
              navigation: false,
              enableLighting: true
            });
            //去掉超图supermap
            viewer._cesiumWidget._creditContainer.style.display = "none";
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
            
            viewer.scene.globe.enableLighting = true
            viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)
            viewer.imageryLayers.removeAll()
            const labelImagery = new Cesium.TiandituImageryProvider({
              mapStyle : Cesium.TiandituMapsStyle.TER_C, //天地图全球中文注记服务（经纬度投影）
              token: '4a00a1dc5387b8ed8adba3374bd87e5e'
            });
            viewer.imageryLayers.addImageryProvider(labelImagery);

              // viewer.imageryLayers.addImageryProvider(new Cesium.SuperMapImageryProvider({
              //   url:"http://192.168.1.8:8090/iserver/services/map-par/rest/maps/par",
              //   layersID:'100bfdc966fe4343acfc266b5161c239_9ccb94874d98461388d607bc6d44084f'
              // }))
            this.CesiumMeasure = new Cesium_measure(viewer)
            this.CesiumMeasure.initCemian()
            this.CesiumMeasure.initCeJu()
        },
        creatWind(){
          let that = this
          if(!this.initWind){
            axios.get('config/winds.json').then(res => {
                if (res.data) {
                    let data = res.data
     
                    var scene = viewer.scene;
                    scene.skyBox.show = false;
                    viewer.scene.skyBox.show = false;
                    viewer.scene.sun.show = false;
                    // viewer.scene.bloomEffect.show = true; //启用泛光效果
                    viewer.scene.bloomEffect.threshold = 0.5;
                    viewer.scene.bloomEffect.bloomIntensity = 2;

                    var colorTable = new Cesium.ColorTable();
                    colorTable.insert(2, new Cesium.Color(254 / 255, 224 / 255, 139 / 255, 0.95));
                    colorTable.insert(2, new Cesium.Color(171 / 255, 221 / 255, 164 / 255, 0.95));
                    colorTable.insert(2, new Cesium.Color(104 / 255, 196 / 255, 160 / 255, 0.95));
                    colorTable.insert(4, new Cesium.Color(44 / 255, 185 / 255, 156 / 255, 0.95));
                    colorTable.insert(4, new Cesium.Color(25 / 255, 169 / 255, 178 / 255, 0.95));
                    colorTable.insert(7, new Cesium.Color(50 / 255, 136 / 255, 189 / 255, 0.95));
                    colorTable.insert(10, new Cesium.Color(31 / 255, 110 / 255, 183 / 255, 0.95));
                    colorTable.insert(15, new Cesium.Color(5 / 255, 98 / 255, 184 / 255, 0.95));
                    fieldLayer = new Cesium.FieldLayer3D(scene.context); //场数据图层
                    fieldLayer.particleVelocityFieldEffect.velocityScale = 0.4 * 100.0; //初始化效果
                    fieldLayer.particleVelocityFieldEffect.particleSize = 1.2;
                    fieldLayer.particleVelocityFieldEffect.paricleCountPerDegree = 1;
                    // fieldLayer.particleVelocityFieldEffect._fade0pacity=0.996;
                    scene.primitives.add(fieldLayer); //添加场图层
                    var particleWindField = [];
                    var particleWindInverseField = [];

                    fieldLayer.particleVelocityFieldEffect.colorTable = colorTable;

                    var p = 0;
                    for (var j = 0; j < data.ny; j++) {
                        particleWindField[j] = [];
                        particleWindInverseField[j] = [];
                        for (var i = 0; i < data.nx; i++, p++) {
                            particleWindField[j][i] = data.data[p];
                            particleWindInverseField[j][i] = [-data.data[p][0], -data.data[p][1]];
                        }
                    }
                    fieldLayer.fieldData = particleWindField;
                    that.initWind = true
                    that.showWind = true
                }
            })
          }else{
            fieldLayer.visible = !this.showWind
            this.showWind = !this.showWind
          }
        }
        
    },
    created(){

    },
    mounted(){
        this.initMap()
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 0px;
        padding-left: 12px;
        width: 71px;
        z-index: 100000;
        .left{
            width: 24px;
            height: 160px;
            position: relative;
            //海温
            // background:linear-gradient(
            //   #51A5AD 0%,
            //   #8DD770 14%,
            //   #DDC65C 28%,
            //   #C26E2F 42%,
            //   #B64D23 56%,
            //   #A52919 70%,
            //   #6D070D 84%,
            //   #70295D 100%,
            //   );
            //海升
            // background:linear-gradient(
            //   #FEEEDF 0%,
            //   #FEE1C7 5%,
            //   #FDD4B0 10%,
            //   #FDC89A 15%,
            //   #FDBD86 20%,
            //   #FDB377 25%,
            //   #FDA96A 30%,
            //   #FC9F5D 35%,
            //   #FB944F 40%,
            //   #F88841 45%,
            //   #F47D31 50%,
            //   #F17225 55%,
            //   #EE6A1B 60%,
            //   #EB6213 65%,
            //   #E95C0D 70%,
            //   #E65608 75%,
            //   #E45206 80%,
            //   #E14F04 85%,
            //   #DE4B02 90%,
            //   #DB4800 95%,
            //   #DB4800 100%,
            //   );
            //叶绿素
            // background:linear-gradient(
            //   #000080 0%,
            //   #005CAE 10%,
            //   #00AAD5 20%,
            //   #00F7FB 30%,
            //   #46FFB9 40%,
            //   #92FF6D 50%,
            //   #E0FF1F 60%,
            //   #EED401 70%,
            //   #CF8C03 80%,
            //   #CF8C03 90%,
            //   #9D1106 100%,
            //   );
            //北部海温
            background:linear-gradient(
              #2B598A 0%,
              #4DA0B3 10%,
              #76D270 20%,
              #00F7FB 30%,
              #C67833 40%,
              #BD5E29 50%,
              #AF3B1E 60%,
              #9A1D15 70%,
              #600512 80%,
              #732E69 90%,
              #722F7E 100%,
              );
            .right{
                width: 36px;
                height: 100%;
                position: absolute;
                top: 0;
                left: 30px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }
    }
    .time-step{
      position: absolute;
      left: 260px;
      bottom: 10px;
      z-index: 100000;
    }
}
</style>
